// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatRoutingIssueGroup" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatRoutingIssueCandidateGenShape } from "./chat-routing-issue-candidate.gen";
import { ChatRoutingConsideredCandidateGenShape } from "./chat-routing-considered-candidate.gen";

export const ChatRoutingIssueGroupGenShape = z.strictObject({
  issueIndex: z.number(),
  summary: z.string().optional(),
  confidence: z.number().optional(),
  isPrimary: z.boolean(),
  shortlist: z.array(ChatRoutingIssueCandidateGenShape),
  considered: z.array(ChatRoutingConsideredCandidateGenShape),
});
